import _ from "lodash";
import React from "react";
import HTML5Backend from "react-dnd-html5-backend";
import { withApollo } from "react-apollo";
import { Link } from "react-router-dom";
import { DragDropContext } from "react-dnd";

import ProjectConfigRow from "./ProjectConfigRow";
import ProjectConfigTable from "./ProjectConfigTable";
import ProjectConfigChoices from "./ProjectConfigChoices";
import Utils from "lib/utils";
import fixtures from "../constant";
import css from "../styles";
import { query, withDataAndErrors } from "../graph";
import Loading from "../../etc/Loading";

import GridContainer from "../../../components/Grid/GridContainer";
import ItemGrid from "../../../components/Grid/ItemGrid";
import IconCard from "../../../components/Cards/IconCard";
import RegularCard from "../../../components/Cards/RegularCard";
import Button from "../../../components/CustomButtons/Button";
import IconButton from "../../../components/CustomButtons/IconButton";
import DashboardIcon from "@material-ui/icons/Dashboard";
import AddIcon from "@material-ui/icons/Add";
import Snackbar from "../../callform/components/CustomErrorSnackBar";

class ProjectConfig extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            "loaded": false,
            "choicesModalIsOpen": false,
            "choicesLabel": "",
            "choicesValue": "",
            "choicesId": "",
            "choicesUserType": "",
            "projectName": "",
            "showSave": false
        };

        this.mirrorList = [];
        this.state.callerRows = [];
        this.state.receiverRows = [];
    }
    
    componentDidMount() {
        let _this = this
        this.props.client.query({
            query: query, 
            variables: ({projectId: this.props.match.params.id}),
            fetchPolicy: "network-only",
        }).then((r) => {
            let projects = (r.data.project === null) ? {} : r.data.project;
            projects = JSON.parse(projects.config);

            if (!projects || projects === null || _.isEmpty(projects) || projects == '{}') {
                projects = fixtures;
            }


            const callerProps = projects.properties.caller_props.properties;
            const receiverProps = projects.properties.receiver_props.properties;

            //combine both caller properties and receiver
            let rows = Object.assign({}, callerProps, receiverProps);

            //sort rows based on order field
            rows = _.sortBy(rows, function(o) { return o.order });

            let i = 0;
            for (const [key, value] of Object.entries(rows)) {
                let choices = [];
                let selectedChoice = "";
                let mirror = false;

                for (let x in value.enum) {
                    choices.push({
                        "label": value.enumNames[x],
                        "value": value.enum[x]
                    });
                }

                if (!_.isEmpty(choices))
                    selectedChoice = choices[0].value;

                if (value.mirror)
                    mirror = value.mirror;

                const rowData = {
                        "id": `${value.user}-${i}`,
                        "user": value.user,
                        "title": value.title,
                        "type": value.type,
                        "admin_fixed": value.admin_fixed || false,
                        "disableType": value.disableType || -1,
                        "maxLength": value.maxLength || "",
                        "minLength": value.minLength || "",
                        "max": value.max || "",
                        "min": value.min || "",
                        "choices": choices || [],
                        "selectedChoice": selectedChoice,
                        "required": value.required,
                        "readonly": value.readonly || false,
                        "htmlClass": value.htmlClass || "",
                        "style": value.style || "",
                        "mirror": mirror,
                    };

                if (value.user === "caller")
                    _this.state.callerRows.push(rowData);
                else
                    _this.state.receiverRows.push(rowData);

                if (key == (rows.length - 1))
                    this.showSaveBtn();

                i++;
            }
            this.setState({
                "loaded": true,
                "projectName": r.data.project.name,
                "active": r.data.project.active
            })
        })
    }

    showSaveBtn() {
        setTimeout(() => {
            this.setState({showSave: true});
        }, 1000);
    }

     moveRow(id, afterId, rowType) {
        try {
            const idRowType = id.slice(0, id.indexOf("-"));
            const afterIdRowType = afterId.slice(0, afterId.indexOf("-"));

            if (idRowType !== afterIdRowType) {
                //checks if row is dragged in caller table or receiver table
                //returns if row is dragged in different table type
                return;
            } 

            const stateRows = rowType === "caller" ? this.state.callerRows : this.state.receiverRows;
            let newRows = Object.assign([], stateRows);

            let currentRow = _.filter(newRows, function (r) { return `${rowType}-${r.id}` === id;})[0];
            let afterRow = _.filter(newRows, function (r) { return `${rowType}-${r.id}` === afterId;})[0];

            let currentRowIndex = _.findIndex(newRows, function (r) { return r === currentRow });
            let afterRowIndex = _.findIndex(newRows, function (r) { return r === afterRow });

            // remove the current row
            newRows.splice(currentRowIndex, 1);
            // put it after
            newRows.splice(afterRowIndex, 0, currentRow);
            
            this.updateStateRow(rowType, newRows);
        }
        catch(e) {
            console.log(e);
        }
    }

    onRowDelete(rowType, row) {
        if (row.admin_fixed && row.title != 'Speaker ID')
            return;

        const rows = rowType === "caller" ? this.state.callerRows : this.state.receiverRows;
        const index = rows.indexOf(row);
        rows.splice(index, 1);

        this.updateStateRow(rowType, rows);
    }

    onRowAdd(evt) {
        const currentTarget  = evt.currentTarget;

        const rowType = currentTarget.getAttribute("rowtype") || "";
        const rows = rowType === "caller" ? Object.assign([], this.state.callerRows) : Object.assign([], this.state.receiverRows);
        let idCount = this.state.callerRows.length + this.state.receiverRows.length;
        let id = `${rowType}-${idCount++}`;
        
        const newRow = {
            "id": id, //get length as new id for new row
            "title": "",
            "user": rowType,
            "type": "string",
            "minLength": "",
            "maxLength": "",
            "max": "",
            "min": "",
            "choices": [],
            "required": true,
            "admin_fixed": false,
            "disableType": -1,
            "selectedChoice": "",
            "readonly": false,
            "htmlClass": "",
            "style": "",
            "mirror": false
        };

        rows.push(newRow);
        this.updateStateRow(rowType, rows);
    }

    onTableSave(evt) {
        const callerRows = Object.assign([], this.state.callerRows);
        const receiverRows = Object.assign([], this.state.receiverRows);
        let rows = Utils.joinObjectArray(callerRows, receiverRows);

        let properties = {};
        let callerRequiredProp = [];
        let receiverRequiredProp = [];
        let finalDict = {};
        let callerUIOrder = [];
        let receiverUIOrder = [];
        let callerDict = {};
        let receiverDict = {};
        let callerProp = {};
        let receiverProp = {};
        let formData = {
            "caller_props": {}, 
            "receiver_props": {}
        };

        callerDict["type"] = "object";
        receiverDict["type"] = "object";
        // callerDict["title"] = "Caller";
        // receiverDict["title"] = "Receiver";
        
        rows = _(rows).chain().sortBy(function(prop) {
                return prop.order
            }).value();

        rows.map((row, i) => {
            let innerProp = {};
            let titleMap = [];
            // let shouldAdd = true;

            // if (row["title"] === "Carrier" || row["title"] === "Country Code") {
            //     if (!_.isEmpty(row["choices"])) {
            //         if (row["choices"][0]["label"] === "" && row["choices"][0]["value"] === "")
            //             shouldAdd = false;
            //     }
            //     else
            //         shouldAdd = false;
            // }

            // if (!shouldAdd)
            //     return;

            innerProp["title"] = row["title"];
            innerProp["order"] = i;
            innerProp["user"] = row["user"];

            if (row["admin_fixed"])
                innerProp["admin_fixed"] = row["admin_fixed"];

            if (row["disableType"])
                innerProp["disableType"] = row["disableType"];

            if (row["htmlClass"])
                innerProp["htmlClass"] = row["htmlClass"];

            if (row["style"])
                innerProp["style"] = row["style"];

            if (row["readonly"])
                innerProp["readonly"] = row["readonly"];

            if (row["user"] === "caller" && row["mirror"]) {
                this.mirrorList.push(row["title"]);
                innerProp["mirror"] = row["mirror"];
            }

            if (row["user"] === "receiver" && this.mirrorList.includes(row["title"])) {
                innerProp["mirror"] = true;
                innerProp["readonly"] = true;
            }
            else {
                if (row["user"] === "receiver") {
                    innerProp["mirror"] = false;
                    innerProp["readonly"] = false;
                }
            }

            if (row["title"] === "Speaker ID") {
                innerProp["readonly"] = true;
                innerProp["htmlClass"] = "hidden";
                innerProp["style"] = {"display": "none"};
            }

            if (row["minLength"] && (row["title"] != "Age" && !row["title"].includes("(Age)"))) {
                innerProp["minLength"] = parseInt(row["minLength"]);
            }
            else {
                if (row["minLength"]) {
                    if (parseInt(row["minLength"]) !== parseInt(row["min"]))
                        innerProp["min"] = parseInt(row["minLength"]);
                    else
                        innerProp["min"] = parseInt(row["min"]);
                }
                else {
                    if (row["min"])
                        innerProp["min"] = parseInt(row["min"]);
                }
            }

            if (row["maxLength"] && (row["title"] != "Age" && !row["title"].includes("(Age)"))) {
                innerProp["maxLength"] = parseInt(row["maxLength"]);
            }
            else {
                if (row["maxLength"]) {
                    if (parseInt(row["maxLength"]) !== parseInt(row["max"]))
                        innerProp["max"] = parseInt(row["maxLength"]);
                    else
                        innerProp["max"] = parseInt(row["max"]);
                }
                else {
                    if (row["max"])
                        innerProp["max"] = parseInt(row["max"]);
                }
            }

            if (!_.isEmpty(row["choices"])) {
                if (row["title"] === "Carrier" || row["title"] === "Country Code") {
                    if (row["choices"].length == 1) {
                        if (row["choices"][0].value === "") {
                            innerProp["htmlClass"] = "hidden";
                            innerProp["style"] = {"display": "none"};
                        }
                        else {
                            innerProp["htmlClass"] = "";
                            innerProp["style"] = {"display": "block"};
                        }
                    }
                    else {
                        innerProp["htmlClass"] = "";
                        innerProp["style"] = {"display": "block"};
                    }
                }

                innerProp["enum"] = row["choices"].map((choice) => {
                    titleMap.push({
                        "value": choice.value.toString(),
                        "name": choice.label
                    });
                    return choice.value.toString();
                });
                
                innerProp["enumNames"] = row["choices"].map((choice) => {
                    return choice.label;
                });

                innerProp["default"] = row["choices"][0].value.toString();
                innerProp["type"] = "string";
            }
            else if(parseInt(row["disableType"]) === 2) {
                innerProp["enum"] = [""];
                innerProp["enumNames"] = [""];
                innerProp["type"] = "string";
            }
            else {
                innerProp["type"] = row["type"];
            }

            let keyName = row["title"].toLowerCase().replace(/[^a-zA-Z0-9]/g, ""); //remove special characters
            if (row["title"].includes("Phone Number")){
                keyName = "number"
            }
            else if (row["title"].includes("(Age)")){
                keyName = "age"
            }
            keyName = keyName.replace(" ", "_"); //replace spaces to underscore
            keyName = `${row["user".toLowerCase()]}_${keyName}`;

            if (row["user"] === "caller") {
                callerProp[keyName] = innerProp;

                if (!_.isEmpty(row["choices"]) || row["title"] === "Carrier" || row["title"] === "Country Code") {
                    
                    if (row["choices"].length <= 0)
                        formData["caller_props"][keyName] = "";
                    else
                        formData["caller_props"][keyName] = row["choices"][0].value.toString();

                    callerUIOrder.push({
                        key: keyName,
                        type: "select",
                        "titleMap": titleMap
                    });
                }
                else {
                    formData["caller_props"][keyName] = "";
                    callerUIOrder.push(keyName);
                }

                callerRequiredProp.push(keyName);
            }
            else {
                receiverProp[keyName] = innerProp;

                if (!_.isEmpty(row["choices"]) || row["title"] === "Carrier" || row["title"] === "Country Code") {
                    formData["receiver_props"][keyName] = row["choices"][0].value.toString();

                    receiverUIOrder.push({
                        key: keyName,
                        type: "select",
                        "titleMap": titleMap
                    });
                }
                else {
                    formData["receiver_props"][keyName] = "";
                    receiverUIOrder.push(keyName);
                }

                receiverRequiredProp.push(keyName);
            }
        });
        
        receiverDict["properties"] = receiverProp;
        receiverDict["required"] = receiverRequiredProp;
        receiverDict["ui:order"] = receiverUIOrder;
        callerDict["properties"] = callerProp;
        callerDict["ui:order"] = callerUIOrder;
        callerDict["required"] = callerRequiredProp;
        
        properties["caller_props"] = callerDict;     
        properties["receiver_props"] = receiverDict;     
             

        finalDict["properties"] = properties;
        
        finalDict["type"] = "object";
        finalDict["form_data"] = formData;
        finalDict["ui:order"] = {
            "ui:order": ["caller_props", "receiver_props"],
            "caller_props": {
                "classNames": "col-md-6 caller-form-column",
                "ui:order": callerUIOrder
            },
            "receiver_props": {
                "classNames": "col-md-6 receiver-form-column",
                "ui:order": receiverUIOrder
            }
        };

        //execute graphql mutation
        this.props.CreateProjectConfig({ variables: { pid: this.props.match.params.id, config: JSON.stringify(finalDict)}
            }).then(({data}) => {
                console.log("creating project config");
            }).catch(({errors}) => {
                console.log(errors);
            });
    }

    onTableUpdate(evt) {
        let value = evt.target.value;

        if (evt.target.name === "mirror") {
            value = evt.target.checked;
        }

        if (evt.target.name === "key:choices") {
            this.setState({choicesValue: value});
            return;
        }

        if (evt.target.name === "display:choices") {
            this.setState({choicesLabel: value});
            return;
        }

        if (evt.target.name === "choices") {
            if (value === "option:blank")
                return;
            else if (value === "option:add-new") {
                this.onAddChoicesClicked(evt.target.id, evt.target.getAttribute("rowtype"));   
                return;
            }
            else {
                this.setState({choicesLabel: evt.target.options[evt.target.selectedIndex].text});
                this.setState({choicesValue: value});
            }
        }

        const rowType = evt.target.getAttribute("rowtype") || "";

        const item = {
            id: evt.target.id,
            name: evt.target.name,
            value: value
        };

        let rows = rowType === "caller" ? this.state.callerRows : this.state.receiverRows;

        let newRows = rows.map((row, i) => {
            for (const key in row) {
                if (key === item.name && row.id === item.id) {
                    if (item.name === "choices") {
                        row["selectedChoice"] = item.value;
                    }
                    else {
                        row[key] = item.value;
                    }
                }
            }
            return row;
        });

        this.updateStateRow(rowType, newRows);

        return value;
    }

    updateStateRow(type, rows) {
        if (type === "caller")
            this.setState({ callerRows: rows });
        else
            this.setState({ receiverRows: rows });
    }

    closeChoicesModal() {
      this.setState({choicesModalIsOpen: false});

      this.setState({choicesValue: ""});
      this.setState({choicesLabel: ""});
      this.setState({choicesId: ""});
      this.setState({choicesUserType: ""});
    }

    onAddChoicesClicked(id, rowtype) {
        this.setState({choicesModalIsOpen: true});
        this.setState({choicesId: id});
        this.setState({choicesUserType: rowtype});
    }

    onDeleteChoicesClicked(evt, id, rowtype) {
        let rows = rowtype === "caller" ? this.state.callerRows : this.state.receiverRows;

        let newRows = rows.map((row, i) => {
            for (const key in row) {
                if (key === "choices" && row.id === id) {
                    if (row["title"] === "Carrier" || row["title"] === "Country Code") {
                        if (row[key].length <= 1) {
                            alert('Carrier and Country Code must have one option');
                            continue;
                        }
                    }

                    
                    if (!_.isEmpty(row[key])) {
                        let arr = _.without(row[key], _.find(row[key], {
                          value: row["selectedChoice"]
                        }));
                        row[key] = arr;

                        if (!_.isEmpty(row[key])) {
                            row["selectedChoice"] = row[key][0].value;
                        }
                        else {
                            this.setState({choicesValue: ""});
                            this.setState({choicesLabel: ""});
                        }
                    }
                }
            }

            return row;
        });

        this.updateStateRow(rowtype, newRows);
    }

    onChoicesModalSaved(evt) {
        let rows = this.state.choicesUserType === "caller" ? this.state.callerRows : this.state.receiverRows;

        let newRows = rows.map((row, i) => {
            for (const key in row) {
                if (key === "choices" && row.id === this.state.choicesId) {
                    if (!_.isEmpty(row[key])) {
                        let found = false;
                        for (const choiceKey in row[key]) {
                            if (row[key][choiceKey].value === this.state.choicesValue) {
                                row[key][choiceKey].value = this.state.choicesValue;
                                row[key][choiceKey].label = this.state.choicesLabel;
                                found = true;
                            }
                        }

                        if (!found)
                            row[key].push({
                                "label": this.state.choicesLabel,
                                "value": this.state.choicesValue
                            });
                    }
                    else {
                        row[key].push({
                            "label": this.state.choicesLabel,
                            "value": this.state.choicesValue
                        });
                    }
                    row["selectedChoice"] = this.state.choicesValue;
                };
            }
            return row;
        });

        this.updateStateRow(this.state.choicesUserType, newRows);
        this.closeChoicesModal();
    }

    render() {
        const { choicesModalIsOpen, choicesOptions, showSave, active } = this.state;
        let choicesModal = null;
        let saveStyle = "none";

        if (this.props.project.loading)
            return (<Loading />);

        if (showSave)
            saveStyle = "block";


        if (choicesModalIsOpen) {
            choicesModal = <ProjectConfigChoices 
                                closeChoicesModal={this.closeChoicesModal.bind(this)}
                                choicesModalIsOpen={choicesModalIsOpen} 
                                onChoicesModalSaved={this.onChoicesModalSaved.bind(this)}
                                onTableUpdate={this.onTableUpdate.bind(this)}
                                choicesValue={this.state.choicesValue}
                                choicesLabel={this.state.choicesLabel}  />
        }

        const callerBodyRows = this.state.callerRows.map(_.bind(function(row) {
            return (<ProjectConfigRow 
                    id={`${row.user}-${row.id}`}
                    key={row.id}
                    onTableUpdate={this.onTableUpdate.bind(this)} 
                    onRowDelete={this.onRowDelete.bind(this)}
                    onDeleteChoicesClicked={this.onDeleteChoicesClicked.bind(this)}
                    row={row}
                    choicesOptions={choicesOptions}
                    moveRow={this.moveRow.bind(this)}
                    />)
        }, this));

        const receiverBodyRows = this.state.receiverRows.map(_.bind(function(row) {
            return (<ProjectConfigRow 
                    id={`${row.user}-${row.id}`}
                    key={row.id}
                    onTableUpdate={this.onTableUpdate.bind(this)} 
                    onRowDelete={this.onRowDelete.bind(this)}
                    onDeleteChoicesClicked={this.onDeleteChoicesClicked.bind(this)}
                    row={row}
                    choicesOptions={choicesOptions}
                    moveRow={this.moveRow.bind(this)}
                    />)
        }, this));

        let snackbar = null;

        if (!active){
            snackbar = <Snackbar
                formErrorMessage="WARNING: THIS PROJECT IS DEACTIVATED. Fwp Users under this project will not be able to login"
                errorSnackbarOpen={true}
                closeErrorSnackbar={()=>{return false}}
            />
        }
        
        let projectName = this.state.projectName;
        return(
            <GridContainer>
                {snackbar}
                <ItemGrid xs={12}>
                    <IconCard
                        icon={DashboardIcon}
                        title={"Project Config - " + projectName}
                        content={
                            <ItemGrid xs={12}>
                                <ItemGrid style={{textAlign: "right", display: saveStyle}}>
                                    <Link to={{
                                        pathname:`/projects/callform/${this.props.match.params.id}`,
                                    }}
                                    style={{ textDecoration: 'none' }}>
                                        <Button type="button" 
                                            onClick={this.onTableSave.bind(this)}
                                            variant="raised" color="success">Save</Button>
                                    </Link>
                                </ItemGrid>

                                <ItemGrid>
                                    <RegularCard
                                      cardTitle={
                                        <span>
                                            <label>Caller</label>
                                            <span style={css.addBtn}>
                                                <IconButton
                                                    rowtype="caller"
                                                    color="rose"
                                                    onClick={this.onRowAdd.bind(this)}
                                                >
                                                  <AddIcon />
                                                </IconButton>
                                            </span>
                                        </span>
                                      }
                                      content={
                                        <ItemGrid>
                                            <ProjectConfigTable bodyRows={callerBodyRows} />
                                        </ItemGrid>
                                      }
                                    />

                                    <RegularCard
                                      cardTitle={
                                        <span>
                                            <label>Receiver</label>
                                            <span style={css.addBtn}>
                                                <IconButton
                                                    rowtype="receiver"
                                                    color="rose"
                                                    onClick={this.onRowAdd.bind(this)}
                                                >
                                                  <AddIcon />
                                                </IconButton>
                                            </span>
                                        </span>
                                      }
                                      content={
                                        <ItemGrid>
                                            <ProjectConfigTable bodyRows={receiverBodyRows} />
                                        </ItemGrid>
                                      }
                                    />
                                </ItemGrid>
                            </ItemGrid>
                        }
                    />
                </ItemGrid>

                {choicesModal}
        </GridContainer>
        )
    }
}

const win = DragDropContext(HTML5Backend)(ProjectConfig)
export default (withDataAndErrors)(withApollo(win))


// WEBPACK FOOTER //
// ./src/views/projectconfig/components/ProjectConfig.js